import React, {useContext} from 'react';

import {ReactionsContext} from '../../../../website-ui/contexts/reactions-provider';
import {AVAILABLE_REACTION_LIST, permanentReaction, REACTION_ICON_SIZES} from '../constants';

import AddReactionButton from './add-reaction-button';
import {PermanentReaction} from './permanent-reaction';
import Reaction from './reaction';

import styles from '../reactions.module.css';

const CommentReactions = ({
  articleId,
  commentId,
  isFromPreview = false
}) => {
  const {
    reactions,
    handleReactionClick
  } = useContext(ReactionsContext);

  const commentReactions = reactions?.[commentId] || [];

  return (
    <div className={styles.commentReactionsWrapper} id={`js-comment-reactions-${commentId}`}>
      <div className={styles.commentReactionsList}>
        {commentReactions.length === 0 && (
          <PermanentReaction
            onClick={() => handleReactionClick({
              commentId,
              reaction: permanentReaction,
              commentReactions,
              isFromPreview
            })}
          />
        )}
        {commentReactions.map(reaction => (
          <Reaction
            type={reaction.type}
            count={reaction.count}
            key={reaction.type}
            size={REACTION_ICON_SIZES.SMALL}
            isActive={reaction.isUserReaction}
            withCount={reaction.count > 0}
            onClick={() => handleReactionClick({commentId, reaction})}
          />
        ))}
        {commentReactions.length < AVAILABLE_REACTION_LIST.length && (
          <AddReactionButton
            commentId={commentId}
            articleId={articleId}
            commentReactionsLength={commentReactions.length}
            isFromPreview={isFromPreview}
            onReactionClick={reactionType => handleReactionClick({
              commentId,
              reaction: {
                type: reactionType
              },
              commentReactions,
              isFromPreview
            })}
          />
        )}
      </div>
    </div>
  );
};

export default CommentReactions;

